<template>
    <ModalWithButton
        name="cargar-voucher"
        title="Cargar descuentos"
        button_title="Cargar descuentos"
        @cerrar="reset()"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
            <div class="row">
                <div v-if="listas && listas.length > 0" class="col-12">
                    <div class="form-group">
                        <label for="lista_antigua">Seleccione la temporada anterior</label>
                        <ValidationProvider name="lista_antigua" id="lista_antigua" rules="required" v-slot="{ errors }">
                            <multiselect
                                v-model="voucher.lista_antigua"
                                placeholder="Seleccione la temporada anterior"
                                :max-height="95"
                                label="nombre"
                                track-by="id"
                                :options="listas"
                            >
                            </multiselect>
                            <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="row form-group" v-if="voucher.lista_antigua">
                    <FormInput class="col-12" label="Nombre" name="Nombre" rules="required" v-model="voucher.name" />
                    <FormInput class="col-6" label="Descuento (%)" name="Descuento (%)" type="number" v-model="voucher.discount_percent" :disabled="voucher.discount_fixed != 0" />
                    <FormInput class="col-6" label="Descuento (€)" name="Descuento (€)" type="number" v-model="voucher.discount_fixed"  :disabled="voucher.discount_percent != 0" />
                    <FormInput class="col-12" label="Usos" name="Usos" rules="required" type="number" v-model="voucher.units" />
                    <div class="col-12 mb-3">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="customCheckbox26" v-model="voucher.sin_vincular">
                            <label for="customCheckbox26" class="custom-control-label">
                                Válido para todos los precios y regiones
                            </label>
                        </div>
                    </div>
                    <div v-if="!voucher.sin_vincular" class="col-12">
                        <div class="form-group">
                            <label for="temporada">Precios</label>
                            <multiselect
                                v-model="voucher.prices"
                                placeholder="Precios"
                                label="descripcion"
                                track-by="id"
                                :options="precios"
                                :multiple="true"
                            ></multiselect>
                        </div>
                    </div>
                    <b-col cols="12">
                        <b-button type="submit">
                            Guardar
                        </b-button>
                    </b-col>           
                </div> 
            </div>
        </ValidationObserver>   
    </ModalWithButton>  
</template>

<script>
import ModalWithButton from '@/components/backend/components/ModalWithButton.vue';


export default {
    data() {
        return {
            voucher: {
                discount_fixed: 0,
                discount_percent: 0,
            },
            precios: []
        }
    },
    created() {
        this.getPrecios();
    },
    computed: {
        lista_id() {
            return this.$store.getters.getListaId;
        },
        listas() {
            return this.$store.getters.getListas.filter(lista => lista.activa == 0);
        },
    },
    methods: {
        crearVoucher() {
            this.loading = true;

            const lista = this.lista_id;
            const prices = this.voucher.prices?.map(price => price.id);

            const params = {
                lista_id: lista,
                discount_fixed: this.voucher.discount_fixed,
                discount_percent: this.voucher.discount_percent,
                units: this.voucher.units,
                sin_vincular: this.voucher.sin_vincular,
                lista_antigua_id: this.voucher.lista_antigua.id,
                prices: prices,
                name: this.voucher.name
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.cupones.cargar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.cerrar();
                this.$emit('creado');
                this.loading = false;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        },
        cerrar() {
            this.$modal.hide('cargar-voucher')
            this.reset();
        },
        async submit() {
            let isValid = await this.$refs.observer.validate();

            if(this.voucher.sin_vincular){
                this.voucher.prices = []
            }

            if(isValid) {
                this.crearVoucher();
            }
        },
        getPrecios() {
            const params = {
                lista_id: this.lista_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.precios.disponibles'), params).then(res => {
                this.precios = res.data.data;
            });
        },
        reset() {
            this.voucher = {
                lista_id: null,
                discount_fixed: 0,
                discount_percent: 0,
                units: 0,
                sin_vincular: false,
                lista_antigua_id: null,
                prices: [],
                name: ''
            };
        }
    },
    components: {
        ModalWithButton
    }
}
</script>
